import { render, staticRenderFns } from "./NewRegion.vue?vue&type=template&id=6400dff0&scoped=true"
import script from "./NewRegion.vue?vue&type=script&lang=ts"
export * from "./NewRegion.vue?vue&type=script&lang=ts"
import style0 from "./NewRegion.vue?vue&type=style&index=0&id=6400dff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6400dff0",
  null
  
)

export default component.exports